import ReactModal from 'react-modal'

import Text from 'components/common/Text'
import TextButton from 'components/common/TextButton'
import Icon from 'components/Icon'
import theme from 'theme'

const Modal = (props) => (
  <ReactModal css={{ position: 'relative' }} {...props} />
)

export default Modal

export function ModalHeader(props) {
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        margin: '0 auto',
        marginBottom: theme.space[3]
      }}
      {...props}
    />
  )
}

export const ModalCloseButton = (props) => (
  <TextButton
    data-test-close-modal-button
    secondary
    css={{
      position: 'absolute',
      right: theme.space[3],
      top: theme.space[3]
    }}
    {...props}
  >
    <Icon
      css={{
        fontSize: theme.fontSizes[4]
      }}
      icon="close"
    />
  </TextButton>
)

export function ModalTitle(props) {
  return (
    <Text
      as="h3"
      color="dark"
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      weight="bold"
      {...props}
    />
  )
}

export function ModalSubtitle(props) {
  return (
    <Text
      as="h4"
      color="normal"
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      weight="bold"
      {...props}
    />
  )
}
